(function () {
  'use strict';

  const form = document.getElementById('ppContactForm');
  if (!form) return;

  const config = window.ppContactConfig || {};
  const fileInput = document.getElementById('contact-files-input');
  const fileList = document.getElementById('ppContactFileList');
  const hiddenAttachments = document.getElementById('contact-attached-files');
  const submitBtn = form.querySelector('.pp-contact-submit');
  const submitLabel = submitBtn ? submitBtn.querySelector('.pp-contact-submit-label') : null;

  // Pre-fill from URL query string (used by transactional emails to land
  // customers on a partially-completed form: ?name=…&email=…&subject=…&message=…)
  (function prefillFromQuery() {
    if (typeof URLSearchParams === 'undefined') return;
    const params = new URLSearchParams(window.location.search);

    const nameVal = params.get('name');
    if (nameVal) {
      const nameInput = document.getElementById('contact-name');
      if (nameInput) nameInput.value = nameVal;
    }

    const emailVal = params.get('email');
    if (emailVal) {
      const emailInput = document.getElementById('contact-email');
      if (emailInput) emailInput.value = emailVal;
    }

    const subjectVal = params.get('subject');
    if (subjectVal) {
      const subjectSelect = document.getElementById('contact-subject');
      if (subjectSelect) {
        const options = subjectSelect.querySelectorAll('option');
        for (let i = 0; i < options.length; i++) {
          if (options[i].value === subjectVal) {
            subjectSelect.value = subjectVal;
            break;
          }
        }
      }
    }

    const messageVal = params.get('message');
    if (messageVal) {
      const messageTextarea = document.getElementById('contact-message');
      if (messageTextarea) messageTextarea.value = messageVal;
    }
  })();

  const BLOCKED_EXTENSIONS = ['.exe', '.bat', '.cmd', '.com', '.scr', '.ps1', '.msi', '.dll', '.app', '.dmg', '.sh', '.jar', '.vbs', '.js', '.lnk'];

  const state = {
    files: []
  };

  function nextId() {
    return 'f' + Math.random().toString(36).slice(2, 10);
  }

  function fmtSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + ' KB';
    return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  }

  function isBlockedFile(file) {
    const lower = file.name.toLowerCase();
    return BLOCKED_EXTENSIONS.some(ext => lower.endsWith(ext));
  }

  function buildRow(entry) {
    const row = document.createElement('div');
    row.className = 'pp-contact-file-row';
    row.dataset.status = entry.status;
    row.dataset.id = entry.id;

    const info = document.createElement('div');
    info.className = 'pp-contact-file-info';

    const name = document.createElement('span');
    name.className = 'pp-contact-file-name';
    name.textContent = entry.name;

    const size = document.createElement('span');
    size.className = 'pp-contact-file-size';
    size.textContent = fmtSize(entry.size);

    const status = document.createElement('span');
    status.className = 'pp-contact-file-status';
    if (entry.status === 'uploading') {
      const spinner = document.createElement('span');
      spinner.className = 'pp-contact-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      status.appendChild(spinner);
    } else if (entry.status === 'error') {
      status.textContent = entry.error || config.strings.uploadFailed;
    } else if (entry.status === 'uploaded') {
      status.textContent = '✓';
    }

    info.appendChild(name);
    info.appendChild(size);
    info.appendChild(status);

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'pp-contact-file-remove';
    removeBtn.textContent = '×';
    removeBtn.setAttribute('aria-label', config.strings.remove);
    removeBtn.addEventListener('click', () => removeFile(entry.id));

    row.appendChild(info);
    row.appendChild(removeBtn);
    return row;
  }

  function render() {
    while (fileList.firstChild) fileList.removeChild(fileList.firstChild);
    state.files.forEach(entry => fileList.appendChild(buildRow(entry)));

    const urls = state.files
      .filter(f => f.status === 'uploaded' && f.url)
      .map(f => f.url);
    hiddenAttachments.value = urls.join('\n');
  }

  function removeFile(id) {
    const entry = state.files.find(f => f.id === id);
    if (entry && entry.controller) {
      try { entry.controller.abort(); } catch (e) {}
    }
    state.files = state.files.filter(f => f.id !== id);
    render();
  }

  async function uploadFile(file) {
    const id = nextId();
    const controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    const entry = {
      id,
      name: file.name,
      size: file.size,
      status: 'uploading',
      controller
    };
    state.files.push(entry);
    render();

    try {
      const fd = new FormData();
      fd.append('file', file);

      const res = await fetch(config.workerEndpoint, {
        method: 'POST',
        body: fd,
        signal: controller ? controller.signal : undefined
      });

      if (!res.ok) {
        let msg = 'HTTP ' + res.status;
        try {
          const j = await res.json();
          if (j && j.error) msg = j.error;
        } catch (e) { /* ignore */ }
        throw new Error(msg);
      }

      const data = await res.json();
      if (!data || !data.url) throw new Error('Invalid response');

      entry.status = 'uploaded';
      entry.url = data.url;
    } catch (err) {
      if (err && err.name === 'AbortError') {
        return;
      }
      entry.status = 'error';
      entry.error = (err && err.message) ? err.message : config.strings.uploadFailed;
    }
    render();
  }

  function addFiles(filesToAdd) {
    const list = Array.from(filesToAdd);
    for (const file of list) {
      if (state.files.length >= config.maxFiles) {
        alert(config.strings.tooMany);
        break;
      }
      if (isBlockedFile(file)) {
        alert(file.name + ': ' + config.strings.blockedFiletype);
        continue;
      }
      if (file.size > config.maxFileSize) {
        alert(file.name + ': ' + config.strings.tooLarge);
        continue;
      }
      uploadFile(file);
    }
  }

  fileInput.addEventListener('change', (e) => {
    addFiles(e.target.files);
    e.target.value = '';
  });

  form.addEventListener('submit', (e) => {
    const stillUploading = state.files.some(f => f.status === 'uploading');
    if (stillUploading) {
      e.preventDefault();
      alert(config.strings.waitForUploads);
      return;
    }

    const errored = state.files.filter(f => f.status === 'error');
    if (errored.length) {
      const ok = confirm(
        errored.length + ' file(s) failed to upload and will not be sent. Continue?'
      );
      if (!ok) {
        e.preventDefault();
        return;
      }
    }

    if (submitBtn && submitLabel) {
      submitBtn.disabled = true;
      const busy = submitLabel.dataset.labelBusy;
      if (busy) submitLabel.textContent = busy;
    }
  });
})();
